export const SERVICE_CODE = 'INVOICE' + '_SERVICE';
